/**
 * Constants for Catalog module
 */

export const LABELS = {
  productDetails: 'Detalii',
  relatedProducts: 'Produse similare',
} as const
